var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChangeLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8117 13.1883C16.0628 13.4393 16.0628 13.8464 15.8117 14.0974L14.0974 15.8117C13.8464 16.0628 13.4393 16.0628 13.1883 15.8117C12.9372 15.5607 12.9372 15.1536 13.1883 14.9026L14.9026 13.1883C15.1536 12.9372 15.5607 12.9372 15.8117 13.1883Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.5C8 13.2239 8.28277 13 8.63158 13H15.3684C15.7172 13 16 13.2239 16 13.5C16 13.7761 15.7172 14 15.3684 14H8.63158C8.28277 14 8 13.7761 8 13.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8117 8.18829C11.0628 8.43934 11.0628 8.84637 10.8117 9.09743L9.09743 10.8117C8.84637 11.0628 8.43934 11.0628 8.18829 10.8117C7.93724 10.5607 7.93724 10.1536 8.18829 9.90257L9.90257 8.18829C10.1536 7.93724 10.5607 7.93724 10.8117 8.18829Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.5C8 10.2239 8.28277 10 8.63158 10H15.3684C15.7172 10 16 10.2239 16 10.5C16 10.7761 15.7172 11 15.3684 11H8.63158C8.28277 11 8 10.7761 8 10.5Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeLink);
export default __webpack_public_path__ + "static/media/changeLink.0c3bf233.svg";
export { ForwardRef as ReactComponent };